import { useQuery } from '@tanstack/react-query';
import { apiCall } from '@/lib/api-client';

export interface RecentNote { domain: string; text: string; }
export type RecentFindhelpStatus = 'pending' | 'uploaded' | 'flagged' | 'no_medicaid';

export interface RecentCompleted {
  screeningId: string;
  assignmentId: string;
  submittedAt: string;
  totalDurationSec: number | null;
  timeCategory: string | null;
  cinHash: string;
  positiveFindingsCount: number;
  safetyConcernFlag: boolean;
  notes: RecentNote[];
  findhelpStatus: RecentFindhelpStatus;
}

export function useRecentCompleted(limit = 5) {
  return useQuery({
    queryKey: ['agents', 'me', 'completed', limit],
    queryFn: () => apiCall<RecentCompleted[]>(`/agents/me/completed?limit=${limit}`),
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}
